import { MetricModel } from 'src/app/shared/models/metric.model'
import {
  createPaintExpression,
  getSpeedProfileMetricPaint,
} from '../utils/paint/speed-profile-metrics-paint-utils'
import { speedProfileLegend } from './legends/speed-profile-legend'

export const getSpeedProfileMetricFromMap = (): MetricModel => {
  return {
    name: 'average_speed',
    expression: createPaintExpression('average_speed', getSpeedProfileMetricPaint('average_speed')),
    key: 'average_speed',
    legend: speedProfileLegend,
  }
}
